"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _addReducer(globalStateManager, name, reducer) {
    return globalStateManager.addReducer(name, reducer);
}
exports.default = _addReducer;
;
